export  const regex = new RegExp('^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$');